<template>
    <section class="minimal-information-edit">
        <InfosCampanhaFormEdit />
        <DoseQuantificationCampaignEditForm @priceRange="handlePriceRange" />
    </section>
</template>

<script>
import InfosCampanhaFormEdit from '../Forms/InfosCampaignEditForm.vue';
import DoseQuantificationCampaignEditForm from '../Forms/DoseQuantificationCampaignEditForm.vue';
import { busEvent } from '@/main';

export default {
    components: { InfosCampanhaFormEdit, DoseQuantificationCampaignEditForm },

    data() {
        return {
            savingInfosCampanha: false,
            vaccines: []
        }
    },

    mounted() {
        busEvent.$on('vaccinesEdited', (vaccines) => {
            this.vaccines = vaccines;
        });
    },

    methods: {
        handlePriceRange(priceRangeData) {
            const updatedVaccines = this.vaccines.map(vaccine => {
                return { ...vaccine, priceRange: priceRangeData.usePriceRange };
            });
            
            busEvent.$emit('vaccinesEdited', updatedVaccines);
        }
    }
}
</script>
